import { SpacingValues } from "@/lib/utils/SpacingValues";
import { Box } from "@stenajs-webui/core";
import { Card, CardHeader } from "@stenajs-webui/elements";
import { LoadingScreen } from "@stenajs-webui/panels";
import * as React from "react";
import { useCallback } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { EditMultiLegRouteAgreementForm } from "../../product-and-price/multileg-agreement/details/edit-multi-leg-route-agreement-form/EditMultiLegRouteAgreementForm";
import { EditRouteAgreementForm } from "../components/EditRouteAgreementForm";
import { useCanCustomerChangeRouteAgreementTypeQuery } from "../hooks/UseCanCustomerChangeRouteAgreementTypeQuery";
import { RoutesFormModel } from "../types/RoutesFormModel";
import { routesFormRedux } from "../redux/RoutesFormRedux";
import { clearAllPriceStatisticsForRouteAgreement } from "../redux/thunks/ClearAllPriceStatisticsForRouteAgreement";
import { routeAgreementUpdateShouldTriggerRecalculation } from "../lib/RouteAgreementRecalculationDecider";
import {
  HeadAgreementByIdFragment,
  RouteAgreementDetailsStateFragment,
} from "@/gql/graphql";

interface Props {
  customerId: string;
  routeAgreementId: string;
  isMultiLegRouteAgreement: boolean;
  multiLegRoute?: string;
  routeLeg?: string;
  routeAgreement: RouteAgreementDetailsStateFragment;
  multiLegAgreement?: HeadAgreementByIdFragment["multiLegAgrRoutes"]["0"];
}

export const RoutesPanel: React.FC<Props> = ({
  customerId,
  routeAgreementId,
  isMultiLegRouteAgreement,
  multiLegRoute,
  routeLeg,
  routeAgreement,
  multiLegAgreement,
}) => {
  const dispatch = useDispatch();

  const { loading, canChangeRouteAgreementType } =
    useCanCustomerChangeRouteAgreementTypeQuery(customerId);

  const routesFormModel = useSelector(routesFormRedux.selectors.getEntity);

  const setFields = useCallback(
    (fields: Partial<RoutesFormModel>) => {
      dispatch(routesFormRedux.actions.setEntityFields(fields));

      if (routeAgreementUpdateShouldTriggerRecalculation(fields)) {
        dispatch(clearAllPriceStatisticsForRouteAgreement(routeAgreementId));
      }
    },
    [dispatch, routeAgreementId]
  );

  return (
    <>
      <Helmet title="Routes - Route agreement - FPP" />
      <Card>
        <CardHeader text={"Routes"} />
        {loading ? (
          <LoadingScreen />
        ) : !isMultiLegRouteAgreement ? (
          <EditRouteAgreementForm
            value={routesFormModel}
            setFields={setFields}
            disableType={!canChangeRouteAgreementType}
            routeAgreement={routeAgreement}
          />
        ) : (
          <Box spacing={SpacingValues.TWENTYFOUR}>
            <EditMultiLegRouteAgreementForm
              value={routesFormModel}
              setFields={setFields}
              multiLegRoute={multiLegRoute ?? ""}
              routeLeg={routeLeg ?? ""}
              disableType={!canChangeRouteAgreementType}
              multiLegAgreement={multiLegAgreement}
            />
          </Box>
        )}
      </Card>
    </>
  );
};
